import React, { Component } from 'react'
import { connect } from 'react-redux'
import { Translate, FormatDate } from '../../../../utils'
import { ContainerPages, ButtonCLick, InlineElemnt, PlusSvg, DocsTsSvg, Loader, RefreshSvg } from '../../../_Common'
import { ElementGrille, AddGrille, GrilleViewer } from '../utils'
import { evalGrilleActions,exportsActions } from '../../../../actions'
import PropTypes from "prop-types";
import {
    addUrlProps,
    UrlQueryParamTypes
} from "react-url-query";
const urlPropsQueryConfig = {
    currentTab: { type: UrlQueryParamTypes.string },
    tab: { type: UrlQueryParamTypes.string },
    viewGrile: { type: UrlQueryParamTypes.string },
    page: { type: UrlQueryParamTypes.number }
};
class TestGrille extends Component {
    constructor(props) {
        super(props)
        this.state = {
            idGrille: null
        }
        this.handleRefresh = this.handleRefresh.bind(this)
        this.duplicateGrille = this.duplicateGrille.bind(this)
        this.handleAddtest = this.handleAddtest.bind(this)
        this.deleteGrille = this.deleteGrille.bind(this)
        if (props.getEvalGrilleCand !== "1") {
            props.getEvaGrilleCan()
        }

    }
    static defaultProps = {
        currentTab: 'candidate',
        tab: '',
        viewGrile: '',
        page: 0
    }
    static propTypes = {
        currentTab: PropTypes.string,
        tab: PropTypes.string,
        viewGrile: PropTypes.string,
        page: PropTypes.number,
        /********************** */
        onChangeCurrentTab: PropTypes.func,
        onChangeTab: PropTypes.func,
        onChangeViewGrile: PropTypes.func,
        onChangePage: PropTypes.func,
    };
    componentDidMount() {
        document.title = Translate('titles', 'app') + " - " + Translate('sidebar', 'grilletest')
    }
    handleRefresh() {
        this.props.getEvaGrilleCan()
    }
    duplicateGrille(index) {
        const { dataEvalGrilleCand } = this.props
        var grid = dataEvalGrilleCand.grids[index]
        this.state.idGrille = grid.evaluation_grid_id
        this.props.onChangeTab('add')
    }
    handleAddtest() {
        this.state.idGrille = null
        this.props.onChangeTab('add')
    }
    deleteGrille(index) {
        const { dataEvalGrilleCand } = this.props
        let grids = dataEvalGrilleCand.grids
        let grid = grids[index]
        if (grid) {
            this.props.DeleteGrid({ idGrille: grid.evaluation_grid_id, typeGrid: "testConnai" })
        }
    }
    render() {
        const { getEvalGrilleCand, dataEvalGrilleCand, deletingGrid } = this.props
        let griles = [];
        if (getEvalGrilleCand === "1" && dataEvalGrilleCand && Array.isArray(dataEvalGrilleCand.grids)) {
            griles = dataEvalGrilleCand.grids
        }
        return (
            <ContainerPages titlePage={Translate('sidebar', 'grilletest')} contentLeft={<div className="dis-flex">
                <ButtonCLick TextBottun={RefreshSvg} action={this.handleRefresh} />
                <ButtonCLick action={this.handleAddtest} TextBottun={<InlineElemnt first={PlusSvg} classSecend="leftM-5" secend={Translate('grileevalu', 'nvgrille')} />} />
            </div>}>
                {(getEvalGrilleCand === "0" || deletingGrid === "0") && <Loader style={{ minHeight: "250px" }} />}
                {griles.map((grille, key) => {
                    let user = {}
                    if (grille.user) {
                        user = grille.user
                    }
                    return <ElementGrille key={key} iconDoc={DocsTsSvg} exportGrile={()=>exportsActions.ExportGrid({grid:grille.evaluation_grid_id,type:'Blank'},'candidate')} titleGrile={grille.titlegrid} date={FormatDate(grille.created_at, true)} firstName={user.firstname} lastName={user.lastname} duplicateGrille={() => this.duplicateGrille(key)} deleteGrille={() => this.deleteGrille(key)} actionSHow={() => this.props.onChangeViewGrile(grille.evaluation_grid_id)} />
                })}
                {this.props.tab === "add" && <AddGrille isDuplicated={this.state.idGrille} isActive={this.props.tab === "add"} typeGrile="c" actionGrille={this.props.getEvaGrilleCan} Close={this.props.onChangeTab} />}
                {this.props.viewGrile && <GrilleViewer isActive={this.props.viewGrile} Close={this.props.onChangeViewGrile} iconGrille={DocsTsSvg} />}
            </ContainerPages>
        )
    }
}
function mapState(state) {
    const { getEvalGrilleCand, dataEvalGrilleCand, deletingGrid, dataDelGrid } = state.grilleEvalu
    return { getEvalGrilleCand, dataEvalGrilleCand, deletingGrid, dataDelGrid }
}
const actionsClass = {
    getEvaGrilleCan: evalGrilleActions.getEvaGrilleCan,
    DeleteGrid: evalGrilleActions.DeleteGrid
}
const connectedTestGrille = connect(mapState, actionsClass)(TestGrille);
const QueryProps = addUrlProps({ urlPropsQueryConfig })(connectedTestGrille)
export { QueryProps as TestGrille };